module.exports = __webpack_public_path__ + "img/featherland.7f1e74ef.png";